import Vue from 'vue'
import cloneDeep from 'lodash/cloneDeep'

export const state = {
  map: null,
  isLoadingGlobal: false,
  isInitial: true,
  loadingStartTime: null,

  isStreetViewMode: false,

  selectedPoints: [
    {
      id: undefined,
    },
  ],

  fleetAgregate: {},

  pointType: {
    start: false,
    end: false,
  },

  selectedPointIdx: null,

  showResponse: {},
  errorResponse: {},

  liveTrackResponse: {},
  liveTrackVehicleResponse: {},
  liveTrackDriverResponse: {},

  listPointRes: {},
  selectedVehicle: {},

  importFile: undefined,

  locationAllCoord: [],
  locationVehicleWithNextDestination: [],
  activeTab: 'vehicle',
  routeType: 'actual',
}

export const mutations = {
  SET_MAP(state, payload) {
    state.map = payload
  },

  RESET_MAP(state) {
    state.map = null
  },

  SET_ISLOADINGGLOBAL(state, payload) {
    state.isLoadingGlobal = payload
  },

  SET_ISINITIAL(state, payload) {
    state.isInitial = payload
  },

  SET_LOADINGSTARTTIME(state, payload) {
    state.loadingStartTime = payload
  },

  SET_ISSTREETVIEWMODE(state, payload) {
    state.isStreetViewMode = payload
  },

  ADD_SELECTEDPOINTS(state, payload) {
    state.selectedPoints.push(payload)
  },

  SET_SELECTEDPOINTS(state, payload) {
    Vue.set(state.selectedPoints, payload.index, payload.value)
  },

  REMOVE_SELECTEDPOINTS(state, payload) {
    state.selectedPoints.splice(payload.index, 1)
  },

  SWAP_SELECTEDPOINTS(state) {
    const clonedPoints = cloneDeep(state.selectedPoints)
    state.selectedPoints = [clonedPoints[1], clonedPoints[0]]
  },

  SET_ALL_SELECTEDPOINTS(state, payload) {
    state.selectedPoints = payload
  },

  RESET_SELECTEDPOINTS(state) {
    state.selectedPoints = [
      {
        id: undefined,
      },
    ]
  },

  SET_POINTTYPE(state, payload) {
    Vue.set(state.pointType, payload.type, payload.value)
  },

  SET_SELECTEDPOINTIDX(state, payload) {
    state.selectedPointIdx = payload
  },

  SET_LISTPOINTRES(state, payload) {
    state.listPointRes = payload
  },

  RESET_ALLSTATE(state) {
    state.selectedPoints = [
      {
        id: undefined,
      },
    ]

    state.pointType = {
      start: false,
      end: false,
    }

    state.showResponse = {}
    state.errorResponse = {}
    state.listPointRes = {}

    state.isInitial = true
    state.isLoadingGlobal = false
    state.isStreetViewMode = false
    state.selectedPointIdx = null
    state.map = null
    state.selectedVehicle = {}
  },

  SET_SHOWRESPONSE(state, payload) {
    state.showResponse = payload
  },

  SET_ERRORRESPONSE(state, payload) {
    state.errorResponse = payload
  },

  SET_LIVETRACKRESPONSE(state, payload) {
    state.liveTrackResponse = payload.liveTrack
    state.listPointRes = payload.liveTrack
    state.liveTrackVehicleResponse = payload.vehicle
    state.liveTrackDriverResponse = payload.driver
  },

  SET_FLEETAGREGATE(state, payload) {
    state.fleetAgregate = payload
  },

  SET_SELECTEDVEHICLE(state, payload) {
    state.selectedVehicle = payload
  },

  SET_IMPORTFILE(state, payload) {
    state.importFile = payload
  },

  SET_LOCATIONALLCOORD(state, payload) {
    state.locationAllCoord = payload
  },

  SET_LOCATIONVEHICLEWITHNEXTDESTINATION(state, payload) {
    state.locationVehicleWithNextDestination = payload
  },

  SET_ACTIVETAB(state, payload) {
    state.activeTab = payload
  },

  SET_ROUTETYPE(state, payload) {
    state.routeType = payload
    state.selectedPointIdx = null
  },
}

export const actions = {
  setMap({ commit }, payload) {
    commit('SET_MAP', payload)
  },

  resetMap({ commit }) {
    commit('RESET_MAP')
  },

  setIsLoadingGlobal({ commit }, payload) {
    commit('SET_ISLOADINGGLOBAL', payload)
  },

  async setIsLoadingGlobalDelay({ commit, state }, payload) {
    if (payload) {
      commit('SET_LOADINGSTARTTIME', Date.now())
      commit('SET_ISLOADINGGLOBAL', true)
    } else {
      const elapsedTime = Date.now() - state.loadingStartTime
      const minDuration = 1000
      if (elapsedTime < minDuration) {
        await new Promise(resolve => setTimeout(resolve, minDuration - elapsedTime))
      }
      commit('SET_ISLOADINGGLOBAL', false)
    }
  },

  setIsInitial({ commit }, payload) {
    commit('SET_ISINITIAL', payload)
  },

  setLoadingStartTime({ commit }, payload) {
    commit('SET_LOADINGSTARTTIME', payload)
  },

  setIsStreetViewMode({ commit }, payload) {
    commit('SET_ISSTREETVIEWMODE', payload)
  },

  fitMapBounds({ commit }, payload) {
    commit('FIT_MAP_BOUNDS', payload)
  },

  addSelectedPoints({ commit }, payload) {
    commit('ADD_SELECTEDPOINTS', payload)
  },

  setSelectedPoints({ commit }, payload) {
    commit('SET_SELECTEDPOINTS', payload)
  },

  removeSelectedPoints({ commit }, payload) {
    commit('REMOVE_SELECTEDPOINTS', payload)
  },

  swapSelectedPoints({ commit }) {
    commit('SWAP_SELECTEDPOINTS')
  },

  setAllSelectedPoints({ commit }, payload) {
    commit('SET_ALL_SELECTEDPOINTS', payload)
  },

  resetSelectedPoints({ commit }) {
    commit('RESET_SELECTEDPOINTS')
  },

  setPointType({ commit }, payload) {
    commit('SET_POINTTYPE', payload)
  },

  setSelectedPointIdx({ commit }, payload) {
    commit('SET_SELECTEDPOINTIDX', payload)
  },

  setListPointRes({ commit }, payload) {
    commit('SET_LISTPOINTRES', payload)
  },

  resetAllState({ commit }) {
    commit('RESET_ALLSTATE')
  },

  setShowResponse({ commit }, payload) {
    commit('SET_SHOWRESPONSE', payload)
  },

  setLiveTrackResponse({ commit }, payload) {
    commit('SET_LIVETRACKRESPONSE', payload)
  },

  setErrorResponse({ commit }, payload) {
    commit('SET_ERRORRESPONSE', payload)
  },

  setFleetAgregate({ commit }, payload) {
    commit('SET_FLEETAGREGATE', payload)
  },

  setSelectedVehicle({ commit }, payload) {
    commit('SET_SELECTEDVEHICLE', payload)
  },

  setImportFile({ commit }, payload) {
    commit('SET_IMPORTFILE', payload)
  },

  setLocationAllCoord({ commit }, payload) {
    commit('SET_LOCATIONALLCOORD', payload)
  },

  setLocationVehicleWithNextDestination({ commit }, payload) {
    commit('SET_LOCATIONVEHICLEWITHNEXTDESTINATION', payload)
  },

  setActiveTab({ commit }, payload) {
    commit('SET_ACTIVETAB', payload)
  },

  setRouteType({ commit }, payload) {
    commit('SET_ROUTETYPE', payload)
  },
}

export const getters = {
  pointMarkers: (state) => {
    return state.selectedPoints.filter((point) => point.id != undefined)
  },

  hasStartPoint: (state) => {
    if (!state?.listPointRes?.points) {
      return false
    }

    return state.listPointRes.points[0].type === 'START'
  },

  selectedPoint: (state) => {
    if (state.selectedPointIdx === null) {
      return undefined
    }

    return state.listPointRes.points[state.selectedPointIdx]
  },

  currentVehicle: (state) => {
    if (!(state.selectedVehicle && state?.selectedVehicle?.id)) return {}

    const { licensePlate, ...otherProps } = state.selectedVehicle

    return {
      ...otherProps,
      license_plate: licensePlate,
    }
  },

  currentDriver: (state) => {
    if (!(state.showResponse?.driver && state.showResponse?.driver?.id)) return {}

    const { phone, ...otherProps } = state.showResponse.driver

    return {
      ...otherProps,
      phone_no: phone,
    }
  }
}
